<template>
  <div class="pm-dialog-pilot">

    <vs-tabs v-model="activeTab" alignment="center" color='#346c88'>
      <vs-tab v-for="(pilotKanaMaster, index) in pilotKanaMasterList" :key="index" :label="pilotKanaMaster.value" color='#346c88'>
        <div class="flex justify-center outer-area" >
          <div class="vs-row w-full" >
            <div v-for="(master,index) in masterList" :key="index">
              <div class="candidate-list vs-col w-1/6" v-if="master.kana && pilotKanaMaster.candidate && pilotKanaMaster.candidate.includes(master.kana.slice(0,1)) || (pilotKanaMaster.value==='未分類' && !master.kana )" >
                <vs-button
                  :color="itemColor(master.id)"
                  :transparent="itemTransparent(master.id)"
                  :class="[ itemTransparent(master.id) ? 'pm-chip-with-border' : 'pm-chip-without-border' ]"
                  @mousedown="onClick(master.id)"
                >
                  {{ master.short_name || master.name }}
                </vs-button>
              </div>
            </div>
          </div>
        </div>

      </vs-tab>
    </vs-tabs>

    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      activeTab: 0,
      selectedData: {},
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      let pilotMasterList = this.masterMap['pilot'];
      return pilotMasterList;
    },
    enableSave() {
      return true; // ( [2,3].includes(this.selectedData.status) );
    },
    pilotKanaMasterList() {
      let pilotKanaMasterList = JSON.parse(JSON.stringify(this.masterMap['pilot_kana']));
      if ( this.masterList.filter(x => !x.kana ).length > 0 && !pilotKanaMasterList.find(x => x.value === "未分類"  )) {
        pilotKanaMasterList.push({ id: null, value: "未分類", candidate: "" });
      }
      return pilotKanaMasterList;
    },    
  },
  methods: {
    initData() {
      this.selectedData = this.valueMap ? { id: this.valueMap.id  ,status: this.valueMap.status } : {};
      this.activeTab = 0;
      this.$nextTick(() => {
        const selectedData = this.masterList.find(x => x.id === this.selectedData.id);
        if (selectedData) {
          this.pilotKanaMasterList.forEach((pilotKanaMaster, index) => {
            if ( selectedData.kana && pilotKanaMaster.candidate && pilotKanaMaster.candidate.includes(selectedData.kana.slice(0,1)) || (pilotKanaMaster.value==='未分類' && !selectedData.kana ) ) {
              this.activeTab = index;
            }
          });
        }
      });
    },
    itemColor(masterId) {
      let itemColorCode = '#828282';
      if ( masterId === this.selectedData.id ) {
         if ( this.selectedData.status === 2 ) {
           itemColorCode = '#081e29';
         } else if (this.selectedData.status === 3 ) {
           itemColorCode = '#21526d';
         }
      }
      return itemColorCode;
    },
    itemTransparent(masterId) {
      let isTransparent = false;
      if ( masterId === this.selectedData.id ) {
         if ( this.selectedData.status === 2 ) {
           isTransparent = true;
         }
      }
      return isTransparent;
    },
    onClick(clickId) {
      if (this.selectedData.id === clickId ) {
        this.selectedData.status = ( this.selectedData.status % 3 ) + 1;
        if ( this.selectedData.status === 2 ) { this.selectedData.status = 3; } // 予約状態は存在しない。 
      } else {
        this.selectedData = {
          id: this.masterList.find(master => master.id === clickId).id,
          status: 3,
        };
      }
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = ["update"];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey + '#id'] = {};
      updateKeyValueMap[this.columnKey + '#id'][this.selectedData.id] = this.selectedData.status;
      this.$emit('updateValue', this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-pilot {
  .outer-area {
    padding: 1rem;
    max-height: 19rem;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .candidate-list {
    margin: 0rem;
    min-height: 3.2rem;
  }
  .vs-tabs--btn {
    min-height: 3rem;
    color: $pm-dark-gray;
    border: 1px solid $pm-navy;
    border-radius: 2px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    :hover {
      color: $pm-black;
    }
  }
  .activeChild button.vs-tabs--btn {
    background-color:$pm-navy !important;
    span {
      color: $pm-white;

    }
  }
  .vs-tabs--li {
    margin: 0 0.1rem;
  }
  .vs-tabs--ul {
    border-bottom: 4px solid $pm-navy;
  }
  .con-slot-tabs {
    div {
      transition: unset;
    }
  }
  .pm-chip-with-border {
    width: 96%;
    white-space: nowrap;
    overflow: hidden;
    border:1px solid $pm-navy;
  }
  .pm-chip-without-border {
    width: 96%;
    white-space: nowrap;
    overflow: hidden;
    border:none;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }
}
</style>

